import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import { LinkContext } from "../../LinkProvider";
import laptop from "../../img/Home/laptop.webp";
import Fade from 'react-reveal/Fade';

function TradingDesk() {
  const { link } = useContext(LinkContext);
  const { t } = useTranslation();

  return (
    <section className="bg-white md:px-5">
      <Fade bottom>
      <div className="mx-auto flex w-full max-w-[1220px] flex-col md:flex-row md:items-center md:justify-between">
        <img
          src={laptop}
          alt={t("homeDesk.imageAlt")}
          className="h-[205px] object-cover xl:h-auto w-full xl:w-[592px] md:order-2"
        />

        <div className="px-[20px] pb-[48px] pt-[27px] md:order-1 md:w-[42%] md:max-w-[462px] md:bg-none md:px-[46px] md:py-0 xl:px-0">
          <h2 className="font-['Nunito_Sans'] text-[32px] font-black leading-[1.5] text-[#3273B4] xl:text-[42px]">
            <span className="md:hidden">
              <span className="block">{t("homeDesk.mobileTitle.1")}</span>
              <span className="block">{t("homeDesk.mobileTitle.2")}</span>
            </span>
            <span className="hidden md:block">{t("homeDesk.title")}</span>
          </h2>
          <span className="mt-[7px] block h-[2px] w-[121px] bg-[#05193A] md:mt-[12px] md:h-[4px] md:w-[97px]" />
          <p className="mt-[19px] max-w-[315px] font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193A] md:mt-[22px] md:max-w-[380px] md:text-[16px]">
            {t("homeDesk.text")}
          </p>
          <a
            href={link}
            className="mt-[29px] inline-flex h-[40px] items-center justify-center rounded-[9px] bg-[#05193A] px-[29px] font-[Inter] text-[14px] font-light text-white transition-colors hover:bg-[#0d2c60] md:mt-[43px] md:h-[42.386px] md:rounded-[10px] md:px-[35px] md:text-[16px]"
          >
            {t("header.openAccount")}
          </a>
        </div>
      </div>
      </Fade>
    </section>
  );
}

export default TradingDesk;
